import { getReportDirectory } from '@/infrastructure/api-functions/report';
import type { CatalogItem } from '@/types';
import { createGlobalState } from '@vueuse/core';
import { computed, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import _ from 'lodash';

export const useDirectory = createGlobalState(() => {
    const route = useRoute();

    const directoryList = ref<CatalogItem[]>([])

    const loadingDirectory = ref(false)

    const directoryLength = computed(() => directoryList.value.length)

    const isAllFinished = computed(() => {
        return _.every(directoryList.value, item => item.finished);
    })

    function updateDirectoryFinishStatus(taskKey: string, finished = true) {
        if (!directoryList.value.length) return
        directoryList.value.forEach(d => {
            if (d.task_group_type === taskKey) {
                d.finished = finished
            }
        })
    }

    async function getDirectoryList() {
        loadingDirectory.value = true
        try {
            directoryList.value = await getReportDirectory(route.params.projectId as string);
            directoryList.value = directoryList.value.map((item) => { item.finished = false; return item });
        } finally {
            loadingDirectory.value = false
        }
    }

    function refreshCatalogList() {
        directoryList.value = []
        getDirectoryList()
    }

    watch(() => route.params.projectId, (v) => {
        if (!v) return;
        refreshCatalogList()
    }, {
        immediate: true,
    })

    return {
        directoryList,
        directoryLength,
        isAllFinished,
        updateDirectoryFinishStatus,
        loadingDirectory,
        refreshCatalogList,
    }
})
